var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.25651 14.498H0.0898438V9.83132C0.0909234 8.43998 0.643833 7.10587 1.62728 6.12165C2.61073 5.13744 3.94441 4.58349 5.33576 4.58133L8.16084 4.4915V0.75L13.5783 6.17091C13.9063 6.49908 14.0906 6.94412 14.0906 7.40816C14.0906 7.8722 13.9063 8.31723 13.5783 8.64541L8.16201 14.0663V10.3248L5.33576 10.4147C4.25379 10.4167 3.21676 10.8476 2.45207 11.6131C1.68738 12.3786 1.25744 13.416 1.25651 14.498ZM5.33984 9.24799L9.33101 9.15816V11.25L12.7575 7.82058C12.8669 7.71118 12.9283 7.56284 12.9283 7.40816C12.9283 7.25348 12.8669 7.10513 12.7575 6.99574L9.32809 3.56633V5.65816L5.33576 5.74799C4.25308 5.74892 3.215 6.17943 2.44943 6.945C1.68386 7.71057 1.25335 8.74864 1.25243 9.83132V11.2016C1.74366 10.5913 2.36551 10.099 3.07218 9.76095C3.77886 9.42286 4.55237 9.24757 5.33576 9.24799H5.33984Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendReturn);
export default __webpack_public_path__ + "static/media/send-return.592a69d15bb60194d7ccfa41e348467b.svg";
export { ForwardRef as ReactComponent };